import Storage from "@/services/storage";
import { StorageConstants } from "@/enums/storage.enum";
import Parse from "parse/dist/parse.min.js";
import { CounterBack4AppInterface } from "@/interface/business/business";

/**
 * Counter BackForApp Class
 */
class CounterBack4App implements CounterBack4AppInterface {
  counter: number = 0;
  businessId: string = "";

  constructor() {
    Parse.initialize(
      "n0VJqoB9CFmAN4ymJ657JRXahqlMP47PiLufdE26",
      "hMsTWadybQGU4FTpwc4dPMV9k75FbQ905l22SGRA",
      "2INYDbRxzoJDNhGVpYOUiZNbpySwmLoFB4W8wVAa"
    );

    Parse.serverURL = "https://parseapi.back4app.com/";
    this.businessId = Storage.get(StorageConstants.BUSINESS).id;
  }

  async setCounter(): Promise<void> {
    const business_counter = Parse.Object.extend("business_counter");
    const query = new Parse.Query(business_counter);
    query.equalTo("business_id", this.businessId);

    await query
      .first()
      .then((record) => {
        if (record) {
          record.increment("counter");
          record.save();
          this.counter = record.get("counter");
          return;
        }

        const new_business_counter = new business_counter();
        new_business_counter.set("counter", 1);
        new_business_counter.set("business_id", this.businessId);
        new_business_counter.save();
        this.counter = 1;
      })
      .catch((error) => {
        const date = new Date();
        this.counter =
          date.getFullYear() +
          date.getMonth() +
          date.getDate() +
          date.getHours() +
          date.getMinutes() +
          date.getSeconds() +
          date.getMilliseconds();
      });
  }

  /**
   * Handle on Un Subscribe
   * @return {void}
   */
  unSubscribe(): void {
    Parse.Object.destroyAll("business_counter");
  }
}

export default CounterBack4App;

// @references:
// https://docs.parseplatform.org/js/guide/#live-queries
